import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Route, Switch } from "react-router-dom";
import LmsIntegrationIndex from "./LmsIntegrationIndex";
import SEO from "../../../UI/SEO/SEO";
import { getAdminBaseRoute } from "../AdminRoutes";
import LmsIntegrationEdit from "./LmsIntegrationEdit";
export const getLmsIntegrationBaseRoute = () => getAdminBaseRoute() + "/lmsIntegration";
export const getLmsIntegrationIndexRoute = getLmsIntegrationBaseRoute;
export const getLmsIntegrationEditRoute = () => getLmsIntegrationBaseRoute() + "/edit";
const AdminLmsIntegrationRoutes = () => (_jsxs(_Fragment, { children: [_jsx(SEO, { title: "Lms Integration" }), _jsxs(Switch, { children: [_jsx(Route, { component: LmsIntegrationEdit, path: getLmsIntegrationEditRoute() }), _jsx(Route, { component: LmsIntegrationIndex, path: getLmsIntegrationIndexRoute() })] })] }));
export default AdminLmsIntegrationRoutes;
